module.exports = __webpack_public_path__ + "img/list-hover.1c643c87.svg";